// extracted by mini-css-extract-plugin
module.exports = {"menuLinksSection":"mobile-nav-link-list_menuLinksSection__crXjZ"};